
// @ts-ignore
import {getConfig, getLanguageConfig} from "../../utils/config-helper";
// @ts-ignore
import {translate} from '@elements/translations';
import {ref, computed, reactive, onMounted, defineComponent, PropType} from 'vue';
import NumberSpinner from "../../components/form-elements/NumberSpinner.vue";
import {
    convertInCurrency,
    ISOStringToDate
} from "../../utils/utils";
// @ts-ignore
import Popper from 'vue3-popper/dist/popper.esm';
import Accordion from "../../components/accordion/Accordion.vue";
import AccordionItem from "../../components/accordion/AccordionItem.vue";

export default defineComponent({
    name: "TimeListConfigurations",
    components: {
        NumberSpinner,
        Popper,
        Accordion,
        AccordionItem
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        allPriceGroups: {
            type: Array,
            required: true,
        },
        timeList: {
            type: Object,
            required: true
        },
        ticketConfiguration: {
            type: Object,
            required: true
        },
        selectedCurrency: {
            type: String,
            required: true
        },
        isB2B: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: ['changePriceGroupCounter'],
    setup(props, {emit}) {
        const pricePerPriceGroup = (priceGroup: String, timeListItem: Object) => {
            return timeListItem?.priceByPriceGroup ? timeListItem?.priceByPriceGroup.filter((element) => element.id === priceGroup)[0] : {};
        }

        const getSelectedItemsCounter = (allPriceGroups: Object, timeListItem: Object, id: String) => {
            let max = timeListItem.max;
            let current = 0;
            let totalPersons = 0;
            let persons = timeListItem.priceByPriceGroup.find(element => element.id === id)?.personsPerItem || 1;

            allPriceGroups.forEach(function (priceGroup) {
                if (props.ticketConfiguration.priceGroupsPerDateTime[timeListItem.time][priceGroup.value]?.counter) {
                    current += props.ticketConfiguration.priceGroupsPerDateTime[timeListItem.time][priceGroup.value]?.counter;
                }
            });

            allPriceGroups.forEach(function (priceGroup) {
                let priceGroupItem = timeListItem.priceByPriceGroup.filter(function (element) {
                    return element.id === priceGroup.value;
                })[0];
                if (props.ticketConfiguration.priceGroupsPerDateTime[timeListItem.time][priceGroup.value]?.counter) {
                    let personCounter = priceGroupItem?.personsPerItem || 1;
                    totalPersons += props.ticketConfiguration.priceGroupsPerDateTime[timeListItem.time][priceGroup.value]?.counter * personCounter;
                }
            });
            if (current >= max || (totalPersons + persons) > max) {
                return 0;
            } else return max;
        }

        const onChangeCounter = (value: Number, priceGroup: String, timeListItem: Object) => {
            emit('changePriceGroupCounter',
                value, {
                    id: priceGroup,
                    price: pricePerPriceGroup(priceGroup, timeListItem),
                },
                timeListItem
            );
        }

        const timeListItemHasPriceGroup = (allPriceGroupsItem, currentTimeListItem) => {
            let containsPriceGroup = false;
            currentTimeListItem.priceByPriceGroup.filter(function (element) {
                if (containsPriceGroup === true) {
                    return;
                }
                containsPriceGroup = element.id === allPriceGroupsItem.value;
            });
            return containsPriceGroup;
        }

        const getPriceGroupSum = (price: Number, priceGroupCounter: Number) => {
            return price * priceGroupCounter;
        }

        const getCounter = (priceGroup: String, timeListItem: Object) => {
            return props.ticketConfiguration.priceGroupsPerDateTime[timeListItem.time][priceGroup]?.counter;
        }

        const getTotal = (timeListItem: Object) => {
            let total = 0;
            props.allPriceGroups.forEach(function (priceGroup) {
                if (timeListItemHasPriceGroup(priceGroup, timeListItem)) {
                    if (props.ticketConfiguration.priceGroupsPerDateTime[timeListItem.time][priceGroup.value]?.counter) {
                        total += getPriceGroupSum(pricePerPriceGroup(priceGroup.value, timeListItem).price, props.ticketConfiguration.priceGroupsPerDateTime[timeListItem.time][priceGroup.value].counter);
                    }
                }
            });
            return total;
        }

        return {
            pricePerPriceGroup,
            getPriceGroupSum,
            getSelectedItemsCounter,
            getTotal,
            timeListItemHasPriceGroup,
            onChangeCounter,
            convertInCurrency,
            getCounter,
            ISOStringToDate,
            translate
        }
    }
})
